import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportsService } from 'src/app/services/reports.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';

@Component({
  selector: 'app-select-method-totem',
  templateUrl: './select-method-totem.component.html',
  styleUrls: ['./select-method-totem.component.scss']
})
export class SelectMethodTotemComponent {

  selected: string = 'phone';

  methodUser!: string;
  idOrder!: string;
  waiting: boolean = false;

  constructor(private dialogRef: MatDialogRef<SelectMethodTotemComponent>, private reportsService: ReportsService, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data) { }

  changeMethod() {
    this.methodUser = null;
    this.idOrder = this.data.order;
  }

  addNumber(num: string) {
    if (this.methodUser && this.methodUser.length < 9) {
      this.methodUser = this.methodUser + num;
    } else if (!this.methodUser) {
      this.methodUser = num;
    }
  }

  // Eliminar el último dígito del número de teléfono
  deleteNumber() {
    if (this.methodUser && this.methodUser.length > 0) {
      this.methodUser = this.methodUser.slice(0, -1);
    }
  }

  // Vaciar el número de teléfono
  clearNumber() {
    this.methodUser = '';
  }

  nextStep() {
    this.waiting = true;
    const payload = {
      phone: this.selected == 'phone' ? '34' + this.methodUser : null,
      email: this.selected != 'phone' ? this.methodUser : null,
      order: this.data.order,
    }
    this.reportsService.sendTicketsMethod(this.selected, payload).subscribe({
      next: (result) => {
        this.waiting = false;
        this.dialogRef.close({ method: this.selected, methodUser: this.methodUser });
      }, error: (err) => {
        this.waiting = false;
        const dialogRef = this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: true,
            text: '¡Vaya! Se ha producido un error al enviar las entradas. Por favor, comprueba que has introducido bien los datos.',
            btnCancel: false
          }
        });
      }
    });

  }

}
